const config = {
    baseURL: 'https://cfobridge.com/usa',
    imageBaseURL: 'https://cfobridge.com/usa',
    paths: {
        banners: '/banners/',
        teams: '/teams/',
        images: '/images/',
        img: '/img/',
        testimonials: 'https://cfobridge.com/uploads/images/'
    }
};

export default config; 